<app-icon-sprite></app-icon-sprite>
@if (showShell) {
    <nav class="app-nav">
        <div class="app-nav__brand" [routerLink]="authService.isUserLoggedIn ? '/upload' : '/login'">
            <span class="app-nav__brand-word">Sapphire AVS</span>
        </div>
        @if ((dbService.clients | async)?.length) {
            <div class="app-nav__divider"></div>
        }
        @if ((dbService.clients | async)?.length) {
            <div class="app-nav__client-picker">
                <app-search-select-autocomplete
                    label="Client"
                    [valueKey]="'clientId'"
                    [displayKey]="'companyName'"
                    [selectedOption]="getSelectedClient()"
                    [loadFn]="loadClients"
                    (selectionChange)="selectClient($event)"
                ></app-search-select-autocomplete>
            </div>
        }
        <div class="app-nav__right">
            <button class="app-nav__icon-btn" (click)="themeService.toggle()" title="Toggle dark mode">
                @if (isDarkTheme) {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><use href="#icon-sun"></use></svg>
                }
                @if (!isDarkTheme) {
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><use href="#icon-moon"></use></svg>
                }
            </button>
            <app-notifications-history [class.hidden]="!authService.isUserLoggedIn || isUnsubscribeRoute"></app-notifications-history>
            <button
                class="app-nav__avatar"
                [matMenuTriggerFor]="accountMenu"
                [class.hidden]="!authService.isUserLoggedIn || isUnsubscribeRoute"
            >
                @if (!organizationData?.logo) {
                    <span>{{ organizationData?.name || userName | initials }}</span>
                }
                @if (organizationData?.logo) {
                    <img [src]="$safeNavigationMigration(organizationData.logo)" alt="Logo" />
                }
            </button>
            <mat-menu #accountMenu="matMenu">
                <div class="menu account-menu">
                    <div class="menu__header">
                        {{ organizationData?.name || userName }}
                    </div>
                    <div class="menu__group-label">Settings</div>
                    <a class="menu__item" routerLink="/settings/details" routerLinkActive="menu__item--active">
                        {{ isAdmin || isSuperAdmin ? 'Organization' : 'User' }}
                    </a>
                    @if (isAdmin || isSuperAdmin) {
                        <a class="menu__item" routerLink="/settings/workflow-preferences" routerLinkActive="menu__item--active">
                            Preferences
                        </a>
                        <a class="menu__item" routerLink="/settings/clients" routerLinkActive="menu__item--active">Clients</a>
                        <a class="menu__item" routerLink="/settings/users" routerLinkActive="menu__item--active">Users</a>
                    }

                    @if (isAdmin || isSuperAdmin) {
                        <div class="menu__group-label">Outreach &amp; Billing</div>
                        <a class="menu__item" routerLink="/settings/outreach" routerLinkActive="menu__item--active">Outreach</a>
                        <a class="menu__item" routerLink="/settings/payments" routerLinkActive="menu__item--active">Payments</a>
                    }
                    @if (isSuperAdmin) {
                        <div class="menu__group-label">Admin</div>
                        <a class="menu__item" routerLink="/settings/admin/payment" routerLinkActive="menu__item--active">Payment Admin</a>
                        <a class="menu__item" routerLink="/settings/admin/reports" routerLinkActive="menu__item--active">Reports Admin</a>
                    }

                    @if (isAdmin || isSuperAdmin) {
                        <div class="menu__divider"></div>
                        <a class="menu__item" routerLink="/activity" routerLinkActive="menu__item--active">Activity</a>
                    }

                    <div class="menu__divider"></div>
                    <button class="account-menu__signout" (click)="logOut()">Sign Out</button>
                </div>
            </mat-menu>
        </div>
    </nav>
    @if (!isUnsubscribeRoute) {
        <aside class="app-sidebar" [class.app-sidebar--rail]="railCollapsed">
            <div
                class="app-sidebar__item app-sidebar__item--group"
                [class.app-sidebar__item--expanded]="libraryNavExpanded"
                [class.app-sidebar__item--active]="isLibraryGroupActive"
                (click)="toggleLibraryNav()"
                matTooltip="Library"
                matTooltipPosition="right"
                matTooltipClass="tooltip-dark"
                [matTooltipDisabled]="!railCollapsed"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><use href="#icon-team"></use></svg>
                Library
                <svg class="app-sidebar__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <use href="#icon-chevron-down"></use>
                </svg>
            </div>
            @if (libraryNavExpanded) {
                <a
                    class="app-sidebar__subitem"
                    routerLink="/library"
                    [routerLinkActiveOptions]="{ exact: true }"
                    routerLinkActive="app-sidebar__subitem--active"
                >
                    Records
                </a>
                <a class="app-sidebar__subitem" routerLink="/library/audits" routerLinkActive="app-sidebar__subitem--active">Audits</a>
            }
            <div
                class="app-sidebar__item app-sidebar__item--group"
                [class.app-sidebar__item--expanded]="correctionsNavExpanded"
                [class.app-sidebar__item--active]="isCorrectionsGroupActive"
                (click)="toggleCorrectionsNav()"
                matTooltip="Corrections"
                matTooltipPosition="right"
                matTooltipClass="tooltip-dark"
                [matTooltipDisabled]="!railCollapsed"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><use href="#icon-inbox"></use></svg>
                Corrections
                <svg class="app-sidebar__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <use href="#icon-chevron-down"></use>
                </svg>
            </div>
            @if (correctionsNavExpanded) {
                <a class="app-sidebar__subitem" routerLink="/upload" routerLinkActive="app-sidebar__subitem--active">Upload</a>
                <a class="app-sidebar__subitem" routerLink="/scanned" routerLinkActive="app-sidebar__subitem--active">Scanned</a>
                <a class="app-sidebar__subitem" routerLink="/reviewed" routerLinkActive="app-sidebar__subitem--active">In review</a>
            }
            <a
                class="app-sidebar__item"
                [class.hidden]="!isAdmin && !isSuperAdmin"
                routerLink="/activity"
                routerLinkActive="app-sidebar__item--active"
                matTooltip="Activity"
                matTooltipPosition="right"
                matTooltipClass="tooltip-dark"
                [matTooltipDisabled]="!railCollapsed"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><use href="#icon-activity"></use></svg>
                Activity
            </a>
            <div class="app-sidebar__spacer"></div>
            @if (isSuperAdmin) {
                <div
                    class="app-sidebar__item app-sidebar__item--group"
                    [class.app-sidebar__item--expanded]="dashboardNavExpanded"
                    [class.app-sidebar__item--active]="isDashboardGroupActive"
                    (click)="toggleDashboardNav()"
                    matTooltip="Dashboard"
                    matTooltipPosition="right"
                    matTooltipClass="tooltip-dark"
                    [matTooltipDisabled]="!railCollapsed"
                >
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                        <use href="#icon-dashboard"></use>
                    </svg>
                    Dashboard
                    <svg class="app-sidebar__chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <use href="#icon-chevron-down"></use>
                    </svg>
                </div>
                @if (dashboardNavExpanded) {
                    <a class="app-sidebar__subitem" routerLink="/dashboard/general" routerLinkActive="app-sidebar__subitem--active">
                        General
                    </a>
                    <a
                        class="app-sidebar__subitem"
                        routerLink="/dashboard/voice-recordings"
                        routerLinkActive="app-sidebar__subitem--active"
                    >
                        Voice recordings
                    </a>
                }
            }
            <a
                class="app-sidebar__item"
                routerLink="/settings"
                routerLinkActive="app-sidebar__item--active"
                matTooltip="Settings"
                matTooltipPosition="right"
                matTooltipClass="tooltip-dark"
                [matTooltipDisabled]="!railCollapsed"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><use href="#icon-settings-gear"></use></svg>
                Settings
            </a>
            <div
                class="app-sidebar__collapse"
                (click)="toggleRail()"
                matTooltip="Expand"
                matTooltipPosition="right"
                matTooltipClass="tooltip-dark"
                [matTooltipDisabled]="!railCollapsed"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <use href="#icon-chevron-double-left"></use>
                </svg>
                Collapse
            </div>
        </aside>
    }
    <div
        class="app-content"
        [class.app-content--rail]="railCollapsed && !isUnsubscribeRoute"
        [class.app-content--no-sidebar]="isUnsubscribeRoute"
        [class.app-content--drawer-open]="drawerOpen"
    >
        <router-outlet></router-outlet>
        <ng-container appSetAsDynamicContainer></ng-container>
    </div>
} @else {
    <router-outlet></router-outlet>
    <ng-container appSetAsDynamicContainer></ng-container>
}

@if (loading) {
    <app-loader></app-loader>
}
<app-toast></app-toast>
